<template>
  <div class="add-form">
    <div class="back-title">
      <span @click="onCancel"><i class="el-icon-back" /> 返回上一级</span>
    </div>

    <div class="form-title">
      <span>{{ form.name }} 的权限组信息</span>
    </div>

    <el-form ref="form"
             label-width="120px"
             label-position="left">
      <el-form-item label="姓名">
        {{ form.name }}
      </el-form-item>
      <el-form-item label="权限类型">
        {{ form.authorization }}
      </el-form-item>
      <el-form-item label="页面路由">
        {{ form.routers }}
      </el-form-item>
      <el-form-item label="创建时间">
        {{ form.created_at }}
      </el-form-item>
      <el-form-item label="最后修改时间">
        {{ form.updated_at }}
      </el-form-item>
      <el-form-item>
        <el-button type="primary"
                   @click="onSubmit">
          修改
        </el-button>
        <el-button type="danger"
                   @click="onDelete">
          删除
        </el-button>
        <el-button @click="onCancel">
          取消
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { queryUserGroup, deleteUserGroup } from '@/api/admin';

export default {
  props: {
    pid: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      form: {},
      query: {
        page: 1,
        size: 20,
      },
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      const constdata = Object.keys(this.$store.state.product).reduce((r, c) => {
        r[c] = this.$store.state.user[c];
        return r;
      }, {});
      const params = Object.assign({}, constdata, this.query);
      params.query_filters = { id: { relationship: 'e', value: [this.pid] } };
      queryUserGroup(params).then((res) => {
        if (res.data && res.data && res.data.list.length > 0) {
          const [form, ..._] = res.data.list;
          this.form = form;
        }
      });
    },
    onDelete() {
      this.$confirm('此操作将永久删除该权限组, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          deleteUserGroup({ id: this.pid }).then((res) => {
            this.$message({
              type: 'success',
              message: '删除成功!',
            });
            this.onCancel();
            this.$store.dispatch('GetInfo');
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    onSubmit() {
      this.$emit('setRPQ', { r: 'add', p: this.pid });
    },
    onCancel() {
      this.$emit('setRPQ', { r: 'list', p: undefined });
    },
  },
};
</script>
